/**********************************************************
Chemical View
**********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UrlList from '../url_list';
import { PRODUCT_URLS } from '../../cult_constants';


class ChemicalContainer extends Component {
  render() {
    return (
      <div className="row">
        <div className="col s12 m1 l1">
          <UrlList listItems={PRODUCT_URLS} id={'cult-url-nav'} />
        </div>
        <div className="col m11 l11">
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ChemicalContainer);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chemical/chemical_container.js